import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/apect/node_modules/lucide-react/dist/esm/Icon.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/apect/src/components/FaqPageClient.tsx");
